import { PhotosAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import {
  IDeletePropertyPhotoDTO,
  IGetPropertyPhotosDTO,
  IPropertyPhotosResponse,
  IUploadPropertyPhotosDTO,
} from '@/models/photos.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PICTURES_SLICE_NAME } from './models';

export const getPropertyPhotos = createAsyncThunk<
  IPropertyPhotosResponse,
  IGetPropertyPhotosDTO,
  { serializedErrorType: IApiError }
>(
  `${PICTURES_SLICE_NAME}/getPropertyPhotos`,
  async (params) => {
    const response = await PhotosAPI.getPropertyPhotos(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const uploadPropertyPhotos = createAsyncThunk<
  IPropertyPhotosResponse,
  IUploadPropertyPhotosDTO,
  { serializedErrorType: IApiError }
>(
  `${PICTURES_SLICE_NAME}/uploadPropertyPhotos`,
  async (params) => {
    const response = await PhotosAPI.uploadPropertyPhotos(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deletePropertyPhoto = createAsyncThunk<
  IPropertyPhotosResponse,
  IDeletePropertyPhotoDTO,
  { serializedErrorType: IApiError }
>(
  `${PICTURES_SLICE_NAME}/deletePropertyPhoto`,
  async (data) => {
    const response = await PhotosAPI.deletePhoto(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
